import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CityModel} from './model/city.model';
import {TesseratoModel} from './model/tesserato.model';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';
import {CodeIdentityModel} from './model/code-identity.model';
import {CardTypeModel} from './model/card-type-model';
import {of} from 'rxjs/observable/of';

@Injectable()
export class TesseramentoService {
  private url = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getSubscriberListLite() {
    return  this.http.get<any[]>(this.url + 'subscriber/all/lite');
  }
  getSubscriberListLiteFiltered(request: any) {
    return  this.http.post<any>(this.url + 'subscriber/all/lite/filtered', request);
  }
  getSubscriberListLiteFilteredComitati(request: any) {
    return  this.http.post<any>(this.url + 'subscriber/all/lite/filtered/comitati', request);
  }
  getSubscriberList() {
    return  this.http.get<any[]>(this.url + 'subscriber/all');
  }
  getSubscriberDocuementTypes() {
    return  this.http.get<any[]>(this.url + 'subscriber/type/document');
  }
  getAutocompleteCityForeign(term: any) {
    return this.http.post<CityModel[]>(this.url + 'location/autocomplete', {idDistrict: 108, city: term});
  }
  getDistrict() {
    return  this.http.get<any[]>(this.url + 'location/districts');
  }
  checkCF(body: any) {
    return this.http.post<TesseratoModel>(this.url + 'utils/subscriber/check/cf', body);
  }
  getDiscipline() {
    return  this.http.get<any[]>(this.url + 'structure/disciplines');
  }
  getTesserato(idSubscriber: number, lite = false) {
    return  this.http.get<any>(this.url + 'subscriber/detail/' + idSubscriber, {params: {lite: lite + ''}});
  }
  getHeaderTesserato(idSubscriber: number) {
    return  this.http.get<any>(this.url + 'subscriber/header/' + idSubscriber);
  }
  getCardsTesserato(idSubscriber: number) {
    return  this.http.get<any>(this.url + 'subscriber/cards/' + idSubscriber);
  }
  getCardTypeLeft(com) {
    if (com){
      return  this.http.get<CardTypeModel[]>(this.url + 'card/type/left/diretto');
    }else{
      return  this.http.get<CardTypeModel[]>(this.url + 'card/type/left');

    }

  }
  getCardTitle() {
    return  this.http.get<CodeIdentityModel[]>(this.url + 'card/movement/title_list');
  }
  checkCard(card: any) {
    return  this.http.get<TesseratoModel>(this.url + 'card/free/' + card);
  }
  getCardTesserato(idSubscriber: number, idCard: number): Observable<Blob> {
    return  this.http.get(this.url + 'card/pdf/' + idSubscriber + '/' + idCard, {responseType: 'blob'});
  }

  getCardTesseratoBulk(request: any): Observable<Blob> {
    return this.http.post(this.url + 'card/pdf', request, {responseType: 'blob'});

  }
  create(request: any): Observable<any[]> {
    return this.http.post<any[]>( this.url + 'subscriber/create', request);
  }
  renew(request: any): Observable<any[]> {
    return this.http.post<any[]>( this.url + 'subscriber/renew', request);
  }
  renewScadenza(request: any): Observable<any[]> {
    return this.http.post<any[]>( this.url + 'subscriber/renew?force=true', request);
  }
  update(request: any): Observable<any[]> {
    return this.http.post<any[]>( this.url + 'subscriber/update', request);
  }
  loadPhoto(file: File, idSubscriber: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any[]>(this.url + 'subscriber/profile_image/' + idSubscriber, formData, {observe: 'response'});
  }
  uploadExcelTesserati(file: File, idStructure: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any[]>(this.url + 'sync_tesserati/load/' + idStructure, formData, {observe: 'response'});
  }
  downloadSubscribersExcel(idStructure: number): Observable<Blob> {
    return  this.http.get(this.url + 'subscriber/excel/' + idStructure, {responseType: 'blob'});
  }
  changeCf(request: any, isCheck: string): Observable<any[]> {
    return this.http.post<any[]>( this.url + 'subscriber/change_cf', request, {params: {isCheck: isCheck}});
  }
  editDiscipline(idCard: number, request: any): Observable<any[]> {
    return this.http.post<any[]>( this.url + 'subscriber/cards/' + idCard, request);
  }
  yearList() {
    return  this.http.get<any>(this.url + 'structure/years');
  }

}





// WEBPACK FOOTER //
// ./src/app/servizi/tesseramento/tesseramento.service.ts